export const AS_HOME_CLAIM_ROUTING_SET_VALUE = "allsureHomeClaim/routing/setValue/";

export const NAVIGATE_PREVIOUS = AS_HOME_CLAIM_ROUTING_SET_VALUE + "navigatePrevious";
export const NAVIGATE_NEXT = AS_HOME_CLAIM_ROUTING_SET_VALUE + "navigateNext";
export const NAVIGATE_INDEX = AS_HOME_CLAIM_ROUTING_SET_VALUE + "navigateIndex";
export const SET_NAVIGATION_DONE = AS_HOME_CLAIM_ROUTING_SET_VALUE + "navigationDone";
export const navigatePrevious = () => ({ type: NAVIGATE_PREVIOUS });
export const navigateNext = () => ({ type: NAVIGATE_NEXT });
export const navigateIndex = (value) => ({ type: NAVIGATE_INDEX, value });
export const setNavigationDone = () => ({ type: SET_NAVIGATION_DONE });

export const RESET_ROUTING =
"allsureHomeClaim/routing/transition/resetState";
export const resetRouting = () => ({ type: RESET_ROUTING });

export const CLAIM_NAME = AS_HOME_CLAIM_ROUTING_SET_VALUE + "claimName";
export const setClaimName = (value) => ({ type: CLAIM_NAME, value });
// IMPLEMENT FOR CVS
// export const SET_NAVIGATION_BACK_TO_PARENT_APP = SET_VALUE_ROUTING + 'navigateBackToParentApp';
// export const SET_NAVIGATION_TO_CVS_FROM_PARENT_APP = SET_VALUE_ROUTING + 'navigateToCVSFromParentApp';
// export const navigateBackToParentApp = () => ({ type: SET_NAVIGATION_BACK_TO_PARENT_APP });
// export const navigateToCVSFromParentApp = ({parentAppUrl, callbackAction, callMeBackSource}) => ({
//     type: SET_NAVIGATION_TO_CVS_FROM_PARENT_APP,
//     parentAppUrl,
//     callbackAction,
//     callMeBackSource,
// });

export const SET_ACTIVE_PAGE_INDEX = AS_HOME_CLAIM_ROUTING_SET_VALUE + "activePageIndex";
export const setActivePageIndex = (value) => ({
  type: SET_ACTIVE_PAGE_INDEX,
  value,
});

// per page transitions
export const ROUTING_TRANSITION = "allsureHomeClaim/routing/transition/";

export const NAVIGATE_TO_CATEGORY_PAGE =
  ROUTING_TRANSITION + "toCategory";

export const navigateToCategoryPage= () => ({
  type: NAVIGATE_TO_CATEGORY_PAGE,
});

export const NAVIGATE_TO_BASIC_DETAILS =
  ROUTING_TRANSITION + "toBasicDetails";

export const navigateToBasicDetails = () => ({
  type: NAVIGATE_TO_BASIC_DETAILS,
});
export const NAVIGATE_TO_INCIDENT_DETAILS =
  ROUTING_TRANSITION + "toIncidentDetails";

export const navigateToIncidentDetails = () => ({
  type: NAVIGATE_TO_INCIDENT_DETAILS,
});

export const NAVIGATE_TO_UPLOAD_DOCUMENTS =
  ROUTING_TRANSITION + "toUploadDocuments";

export const navigateToUploadDocuments = () => ({
  type: NAVIGATE_TO_UPLOAD_DOCUMENTS,
});

export const NAVIGATE_TO_CONFIRMATION = ROUTING_TRANSITION + "toConfirmation";

export const navigateToConfirmation = () => ({
  type: NAVIGATE_TO_CONFIRMATION,
});

export const NAVIGATE_TO_SUCCESS_PAGE = ROUTING_TRANSITION + "toSuccess";
export const navigateToSuccessPage = () => ({ type: NAVIGATE_TO_SUCCESS_PAGE });

export const SCROLL_TO_CLASS = 'allsureHomeClaim/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'allsureHomeClaim/scrolling/transition/scrollToId';
export const CLEAR_SCROLL = 'allsureHomeClaim/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value}),
    scrollToId: (value) => ({type: SCROLL_TO_ID, value}),
}

export const resetScroll = () => ({ type: CLEAR_SCROLL });